import { AttributeEditModeConfig } from '@source-components-react/types';

/**
 * Drawer order, which is also the order the documentation pages are listed in:
 * the URL first because nothing renders without it, then the three settings
 * that only matter once something does.
 */
export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'embed-url-3-resolutions',
    heading: 'Embed URL',
    subHeading:
      'Paste the address of a YouTube or Vimeo video, a Google Maps "Embed a map" link, or a Calendly booking page, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-title-3-resolutions',
    heading: 'Embed Title',
    subHeading:
      'Describe what is being embedded, for screen readers; defaults to the provider name, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-aspect-ratio-3-resolutions',
    heading: 'Embed Aspect Ratio',
    subHeading:
      'The shape of the embed — "16:9" for video, "4:3" for maps, or "none" to set the height on the column instead, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'embed-loading-3-resolutions',
    heading: 'Embed Loading',
    subHeading:
      'Whether the embed loads with the page ("eager") or waits until the visitor scrolls near it ("lazy", the default), for 3 different device resolutions',
    defaultValues: {},
  },
];
